export enum ApprovalAction {
  Approve = 'Approve',
  Reject = 'Reject'
}

export enum ApprovalType{
  Manager = 1,
  Employee = 2,
  FinanceDirector = 3,
}

export interface IApproval {
  action: ApprovalAction;
  comment: string;
}

export interface IApprovalAudit {
  userFirstName: string;
  userLastName: string;
  approvalAction: ApprovalAction;
  approvalType : ApprovalType;
  comment: string;
  createdDate: string;
}

export enum ApprovalStatus {
  Approved = 'Approved',
  Rejected = 'Rejected',
  PendingApproval = 'PendingApproval'
}
